'use client'

import { useTranslations } from 'next-intl'
import { ReactNode, useState } from 'react'
import { Button } from '@/components/button'
import { Modal } from '@/components/modal'

export const AddressSearchPlaceholder = ({
    activate,
    renderInput,
}: {
    activate: () => void
    renderInput: (onOpen: () => void) => ReactNode
}) => {
    const t = useTranslations()
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <>
            {renderInput(() => setIsModalOpen(true))}

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                modalClassNameStyles="max-w-md m-4"
            >
                <div className="flex flex-col items-center gap-4 p-6 text-center">
                    <p className="text-lg font-bold">{t('consent.addressSearch.modal.title')}</p>

                    <p className="text-sm text-gray-600">
                        {t('consent.addressSearch.modal.description')}
                    </p>

                    <div className="flex gap-3">
                        <Button
                            styleType="secondary"
                            shape="pill"
                            onClick={() => setIsModalOpen(false)}
                        >
                            {t('consent.addressSearch.modal.decline')}
                        </Button>

                        <Button
                            styleType="primary"
                            shape="pill"
                            onClick={() => {
                                activate()
                                setIsModalOpen(false)
                            }}
                        >
                            {t('consent.addressSearch.modal.accept')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
